var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { isString } from "lodash";
import { connect } from "@irati/store";
import { H1 } from "@irati/ui/src/Typography";
import Spacing from "@irati/ui/src/Spacing";
import Button from "@irati/ui/src/Button";
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton";
import { FormattedMessage } from "@irati/utils/lang";
import { Para } from "@irati/ui/src/Labels";
import Loading from "@irati/ui/src/Loading";
import Flex from "@irati/ui/src/Flex";
import ModalHeaderImage from "./ModalHeaderImage";
import { ImageModal, StandardModal, Close, Buttons } from "./styled";
var GenericModal = function (_a) {
    var critical = _a.critical, title = _a.title, onHide = _a.onHide, onConfirm = _a.onConfirm, image = _a.image, children = _a.children, actions = _a.actions, proceedButtonText = _a.proceedButtonText, dismissButtonText = _a.dismissButtonText, isMobile = _a.isMobile, load = _a.load, props = __rest(_a, ["critical", "title", "onHide", "onConfirm", "image", "children", "actions", "proceedButtonText", "dismissButtonText", "isMobile", "load"]);
    var Modal = image ? ImageModal : StandardModal;
    var modalBodyMargin = isMobile ? 3 : 5;
    return (React.createElement(Modal, __assign({}, props, { onHide: critical ? function () { } : onHide, image: image }),
        image && React.createElement(ModalHeaderImage, { image: image, margin: modalBodyMargin }),
        React.createElement(Flex, { direction: "column", justifyContent: "space-between", margin: modalBodyMargin },
            React.createElement("div", null,
                image && React.createElement(Spacing, { marginTop: 3 }),
                React.createElement(H1, { marginBottom: 2 }, title),
                !critical && React.createElement(Close, { inline: false, onClick: onHide }),
                isString(children) ? (React.createElement(Para, { marginBottom: 2 },
                    React.createElement(FormattedMessage, { id: children }))) : (children)),
            actions || (React.createElement("div", null,
                React.createElement(Buttons, { justifyContent: "flex-end", alignItems: "center" },
                    React.createElement(Button, { marginRight: isMobile ? undefined : 2, tertiary: true, onClick: onHide },
                        React.createElement(FormattedMessage, { id: dismissButtonText })),
                    React.createElement(ValidationButton, { primary: true, onClick: onConfirm, load: load },
                        React.createElement(FormattedMessage, { id: proceedButtonText }))),
                React.createElement(Spacing, { marginTop: 1 },
                    React.createElement(Loading, { load: load, useLoader: false })))))));
};
GenericModal.defaultProps = {
    proceedButtonText: "platform.button.save",
    dismissButtonText: "platform.button.goBack"
};
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return {
        isMobile: mq.lessThan.medium
    };
};
export default connect(mapStateToProps)(GenericModal);
